/* tslint:disable */
/* eslint-disable */
/**
 * Water Bureau Admin Portal - Debug API
 * Debug APIs for development and testing purposes. These APIs bypass authentication and should only be enabled in development environments.
 *
 * The version of the OpenAPI document: debug-1.0.0
 * Contact: debug@waterbureau.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResponseCouncilDetailDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseCouncilSelfDestructStatusDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseListCouncilListItemDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponsePaginatedResponseDTOCouncilOwnerDTO } from '../backend/model';
// @ts-ignore
import type { ApiResponseVoid } from '../backend/model';
// @ts-ignore
import type { CouncilSelfDestructRequest } from '../backend/model';
// @ts-ignore
import type { UpdateCouncilRequest } from '../backend/model';
/**
 * SuperAdminCouncilControllerApi - axios parameter creator
 * @export
 */
export const SuperAdminCouncilControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncil: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getCouncil', 'councilId', councilId)
            const localVarPath = `/api/councils/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [environment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncils1: async (search?: string, status?: string, environment?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/councils`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (environment !== undefined) {
                localVarQueryParameter['environment'] = environment;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibleOwners: async (councilId: string, search?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getEligibleOwners', 'councilId', councilId)
            const localVarPath = `/api/councils/{councilId}/eligible-owners`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfDestructStatus: async (councilId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('getSelfDestructStatus', 'councilId', councilId)
            const localVarPath = `/api/councils/{councilId}/self-destruct`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilId 
         * @param {CouncilSelfDestructRequest} councilSelfDestructRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSelfDestruct: async (councilId: string, councilSelfDestructRequest: CouncilSelfDestructRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('requestSelfDestruct', 'councilId', councilId)
            // verify required parameter 'councilSelfDestructRequest' is not null or undefined
            assertParamExists('requestSelfDestruct', 'councilSelfDestructRequest', councilSelfDestructRequest)
            const localVarPath = `/api/councils/{councilId}/self-destruct`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(councilSelfDestructRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncil: async (councilId: string, updateCouncilRequest: UpdateCouncilRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'councilId' is not null or undefined
            assertParamExists('updateCouncil', 'councilId', councilId)
            // verify required parameter 'updateCouncilRequest' is not null or undefined
            assertParamExists('updateCouncil', 'updateCouncilRequest', updateCouncilRequest)
            const localVarPath = `/api/councils/{councilId}`
                .replace(`{${"councilId"}}`, encodeURIComponent(String(councilId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouncilRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SuperAdminCouncilControllerApi - functional programming interface
 * @export
 */
export const SuperAdminCouncilControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SuperAdminCouncilControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncil(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilDetailDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncil(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.getCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [environment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCouncils1(search?: string, status?: string, environment?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseListCouncilListItemDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCouncils1(search, status, environment, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.getCouncils1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEligibleOwners(councilId: string, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponsePaginatedResponseDTOCouncilOwnerDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEligibleOwners(councilId, search, page, size, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.getEligibleOwners']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSelfDestructStatus(councilId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilSelfDestructStatusDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSelfDestructStatus(councilId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.getSelfDestructStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilId 
         * @param {CouncilSelfDestructRequest} councilSelfDestructRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestSelfDestruct(councilId: string, councilSelfDestructRequest: CouncilSelfDestructRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseCouncilSelfDestructStatusDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestSelfDestruct(councilId, councilSelfDestructRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.requestSelfDestruct']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCouncil(councilId: string, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseVoid>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCouncil(councilId, updateCouncilRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SuperAdminCouncilControllerApi.updateCouncil']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SuperAdminCouncilControllerApi - factory interface
 * @export
 */
export const SuperAdminCouncilControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SuperAdminCouncilControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncil(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilDetailDTO> {
            return localVarFp.getCouncil(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [search] 
         * @param {string} [status] 
         * @param {string} [environment] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCouncils1(search?: string, status?: string, environment?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseListCouncilListItemDTO> {
            return localVarFp.getCouncils1(search, status, environment, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilId 
         * @param {string} [search] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEligibleOwners(councilId: string, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponsePaginatedResponseDTOCouncilOwnerDTO> {
            return localVarFp.getEligibleOwners(councilId, search, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelfDestructStatus(councilId: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilSelfDestructStatusDTO> {
            return localVarFp.getSelfDestructStatus(councilId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilId 
         * @param {CouncilSelfDestructRequest} councilSelfDestructRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestSelfDestruct(councilId: string, councilSelfDestructRequest: CouncilSelfDestructRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseCouncilSelfDestructStatusDTO> {
            return localVarFp.requestSelfDestruct(councilId, councilSelfDestructRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} councilId 
         * @param {UpdateCouncilRequest} updateCouncilRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCouncil(councilId: string, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResponseVoid> {
            return localVarFp.updateCouncil(councilId, updateCouncilRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SuperAdminCouncilControllerApi - object-oriented interface
 * @export
 * @class SuperAdminCouncilControllerApi
 * @extends {BaseAPI}
 */
export class SuperAdminCouncilControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public getCouncil(councilId: string, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).getCouncil(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [search] 
     * @param {string} [status] 
     * @param {string} [environment] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public getCouncils1(search?: string, status?: string, environment?: string, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).getCouncils1(search, status, environment, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilId 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public getEligibleOwners(councilId: string, search?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).getEligibleOwners(councilId, search, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public getSelfDestructStatus(councilId: string, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).getSelfDestructStatus(councilId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilId 
     * @param {CouncilSelfDestructRequest} councilSelfDestructRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public requestSelfDestruct(councilId: string, councilSelfDestructRequest: CouncilSelfDestructRequest, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).requestSelfDestruct(councilId, councilSelfDestructRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} councilId 
     * @param {UpdateCouncilRequest} updateCouncilRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SuperAdminCouncilControllerApi
     */
    public updateCouncil(councilId: string, updateCouncilRequest: UpdateCouncilRequest, options?: RawAxiosRequestConfig) {
        return SuperAdminCouncilControllerApiFp(this.configuration).updateCouncil(councilId, updateCouncilRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

